import type { BaseElement } from 'slate';

import type {
  AlineContentBlock,
  GlobalStylesMap,
  HeaderFooterProps,
  ListDefinitions,
  SuggestedDocEdit,
} from '../../internal';

export type DocumentType = 'document';
export const documentType: DocumentType = 'document';

export interface PageDimensions {
  /** Height *in inches*. */
  height: number;
  /** Margin bottom *in inches*. */
  marginBottom: number;
  /** Margin left *in inches*. */
  marginLeft: number;
  /** Margin right *in inches*. */
  marginRight: number;
  /** Margin top *in inches*. */
  marginTop: number;
  /** Width *in inches*. */
  width: number;
}

export type DocProps = Omit<DocumentElement, 'children'>;

export interface DocumentElement extends BaseElement {
  children: AlineContentBlock[];
  headerFooter: HeaderFooterProps;
  listDefinitions: ListDefinitions;
  pageDimensions: PageDimensions;
  styleSheet: GlobalStylesMap;
  type: DocumentType;
  defaultTabStopIn?: number;
  schemaVersion?: number;
  suggestedEdits?: SuggestedDocEdit[] | null;
}
